"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LexerErrors = void 0;
const antlr4_1 = require("antlr4");
class LexerErrors extends antlr4_1.ErrorListener {
    _errors;
    constructor() {
        super();
        this._errors = [];
    }
    get errors() {
        return this._errors;
    }
    syntaxError(_recognizer, _offendingSymbol, _line, charPositionInLine, message, _e) {
        const startIndex = _e?.startIndex ?? charPositionInLine ?? 0;
        this._errors.push({
            from: startIndex,
            to: startIndex + 1,
            message,
            severity: 'error',
            error_type: 'lexer',
        });
    }
}
exports.LexerErrors = LexerErrors;
